import Vue from 'vue'
import Router from 'vue-router'
import {ability} from "../store/ability"
import {TokenService} from '@/services/storage.service'

const isAdmin = () => TokenService.getIsAdmin();

import store from "../store/index"
import PriceBarcodeGenerate from "../views/point-of-sale/PriceBarcodeGenerate";
import Index from "../views/aplication-warehouse/Index";
import RequestTransfer from "../views/applications/requestTransfer/index";
import RequestCounter from "../views/applications/counter/index";
import CreateOrUpdateRequestTransfer from "../views/applications/requestTransfer/create_or_update";
import CreateOrUpdateRequestCounter from "../views/applications/counter/CreateOrUpdate";
import RequestDocumentShow from "../views/aplication-warehouse/blocks/RequestDocumentShow";
import RequestDocumentPro from "../views/aplication-warehouse/blocks/RequestDocumentsPro.vue";
import RequestItems from "../views/aplication-warehouse/RequestItems";
import ActExpration from "../views/warehouse-management/wh-documents/pages/actExpration";
import PriceCreate from "../views/point-of-sale/PriceCreate";
import SkyDocNakladnoy from "../views/sky-shop/skyDocNakladnoy";
import reportNakladnoy from "../views/sky-shop/reportNakladnoy";
import Brigade from "../views/sky-shop/brigade";

// Containers
const DefaultContainer = () => import('@/containers/DefaultContainer')


// Views
const Dashboard = () => import('@/views/Dashboard')
const Empty = () => import('@/views/Empty')

// Views - Pages
const Page404 = () => import('@/views/pages/Page404')
const Page500 = () => import('@/views/pages/Page500')
const Login = () => import('@/views/pages/Login')

// Views - Point of sale (POS)
const PosList = () => import('@/views/point-of-sale/pos/PosList');
const Pos = () => import('@/views/point-of-sale/pos/Pos');
const PosReport = () => import('@/views/point-of-sale/report/PosReport');
const BeforePos = () => import ('@/views/point-of-sale/pos/BeforePos');
const beforePos = () => import ('@/views/point-of-sale/new_pos/before_pos');
const transferIncome = () => import ('@/views/point-of-sale/new_pos/transferIncome');
const salesForSeller = () => import ('@/views/point-of-sale/new_pos/sales');
const posV2 = () => import ('@/views/point-of-sale/new_pos/pos');
const PromoToProduct = () => import('@/views/point-of-sale/promo-to-product/PromoToProduct');
const BarcodeDiscount = () => import('@/views/point-of-sale/promo-to-product/blocks/BarcodeDiscount');

// Views - Sky_Shop
const SkySettings = () => import('@/views/sky-shop/settings');
const SkyDoc = () => import('@/views/sky-shop/doc');
const SkyReport = () => import('@/views/sky-shop/report');

// Views - ContractManagement
const ContractType = () => import('@/views/contract-management/type');
const ContractStage = () => import('@/views/contract-management/stage');
const ContractDoc = () => import('@/views/contract-management/doc');

// Views - Warehouse_management

const Warehouse = () => import('@/views/warehouse-management/warehouse/Index');
const WarehouseForPos = () => import('@/views/warehouse-management/warehouse/warehouseForPos');
const WarehousePrices = () => import('@/views/warehouse-management/warehouse/blocks/Prices');
const BookingList = () => import('@/views/warehouse-management/booking/BookingList');
const ItemConvert = () => import('@/views/warehouse-management/item-convert/index');
const ItemConvertCreate = () => import('@/views/warehouse-management/item-convert/CreateOrUpdate');
const ItemConvertView = () => import('@/views/warehouse-management/item-convert/view');
const WholeSaleReport = () => import('@/views/warehouse-management/wholesale/report/WholeSaleReport');
const ExtraCost = () => import('@/views/warehouse-management/extra-cost/List');
const Expenses = () => import('@/views/warehouse-management/expenses/List');
const Adjustment = () => import('@/views/warehouse-management/adjustment/Adjustment');
const ExcelExport = () => import('@/views/warehouse-management/excel-export/ExcelExport');
const Goods = () => import('@/views/warehouse-management/goods/Goods');
const Mxik = () => import('@/views/warehouse-management/mxik/mxik');
const MinMaxValues = () => import('@/views/warehouse-management/min-max-values/index');
const ExpiredItems = () => import('@/views/warehouse-management/expired-items/index');
const termOfItems = () => import('../views/warehouse-management/termOfItems/index.vue');
const termOfItemsView = () => import('../views/warehouse-management/termOfItems/view.vue');
const BarcodeGenerateForGoods = () => import('@/views/warehouse-management/goods/blocks/BarcodeGenerate');
const BarcodeGenerateForIncome = () => import('@/views/warehouse-management/wh-documents/income/pages/BarcodeGenerate');
const PriceGenerateForGoods = () => import('@/views/warehouse-management/goods/blocks/PriceGenerate');

//Warehouse documents
const WhDocuments = () => import('@/views/warehouse-management/wh-documents/List');
const RuminyaNakladnoyWholesale = () => import('@/views/warehouse-management/wholesale/pages/RNakladnoy');
const NakladnoyWholesale = () => import('@/views/warehouse-management/wholesale/pages/Nakladnoy');
const NakladnoyWithGrid = () => import('@/views/warehouse-management/wholesale/pages/NakladnoyWithGrid');
const Wholesale = () => import('@/views/warehouse-management/wholesale/wholesale');
const Inventory = () => import('@/views/warehouse-management/inventory/index');
const InventoryCreateOrUpdate = () => import('@/views/warehouse-management/inventory/CreateOrUpdate');
const InventoryPrint = () => import('@/views/warehouse-management/inventory/Print');
const WhShow = () => import('@/views/warehouse-management/wh-documents/pages/Show');
const WriteOffNakladnoy = () => import('@/views/warehouse-management/wh-documents/pages/writeOffNakladnoy');
const Pricing = () => import('@/views/warehouse-management/wh-documents/pages/Pricing');
const CheckNaklodnoy = () => import('@/views/warehouse-management/wh-documents/pages/checkNoklodnoy');
const ActExprationKirim = () => import('@/views/warehouse-management/wh-documents/pages/actExpration');
const transferPricing = () => import('@/views/warehouse-management/wh-documents/pages/TransferPricing');
const TNakladnoy = () => import('@/views/warehouse-management/wh-documents/pages/TransferNakladnoy');
const ContractViewDoc = () => import('@/views/contract-management/doc-view');
const pricingNakladnoy = () => import('@/views/warehouse-management/wh-documents/pages/pricingNakladnoy');
const PricingPrices = () => import('@/views/warehouse-management/wh-documents/pages/pricingPrices');
const TransferPrices = () => import('@/views/warehouse-management/wh-documents/pages/transferPrices');
const Act = () => import('@/views/warehouse-management/wh-documents/pages/act');
const naklodnoyNew = () => import('@/views/warehouse-management/wh-documents/pages/naklodnoyNew');
const naklodnoyPeredacha = () => import('@/views/warehouse-management/wh-documents/pages/nakladnayaPeredacha');
const Aviz = () => import('@/views/warehouse-management/wh-documents/pages/Aviz');
const AvizDocAll = () => import('@/views/warehouse-management/wh-documents/pages/AvizDocAll');
const WhShowPendingIncome = () => import('@/views/warehouse-management/wh-documents/pages/ShowPendingIncome');
const PricePrint = () => import('@/views/warehouse-management/wh-documents/pages/pricePrint');
const BarcodeGenerate = () => import('@/views/warehouse-management/wh-documents/pages/BarcodeGenerate');
const BarcodeGeneratePage = () => import('@/views/warehouse-management/wh-documents/pages/BarcodeGeneratePage');
const Pending = () => import('@/views/warehouse-management/wh-documents/pages/Pending');
const PendingIncome = () => import('@/views/warehouse-management/wh-documents/pages/PendingIncome');
const PendingIncomeFromSale = () => import('@/views/warehouse-management/wh-documents/income/pages/PendingIncomeFromSale');
const ExtraShow = () => import('@/views/warehouse-management/extra-cost/pages/ExtraCost');
const Sector = () => import('@/views/warehouse-management/sector/Sector');
const TransferByDocument = () => import('@/views/warehouse-management/transfer-by-document/TransferByDocument');

//Warehouse documents
// const Expenditure = () => import('@/views/warehouse-management/expenditure/pages/Show');


// Views - Contracts_management

const Transactions = () => import('@/views/contracts-management/transactions/Transactions')
const Contracts = () => import('@/views/contracts-management/contracts/Contracts')

// Views - Organization_structure
const Departments = () => import('@/views/organization-structure/departments/Departments')
const Employees = () => import('@/views/organization-structure/employee/Employees')

//Views Pos
const Client = () => import('@/views/point-of-sale/Client')
const PriceList = () => import('@/views/point-of-sale/PriceList')
const ItemWithDifferentPrices = () => import('@/views/point-of-sale/ItemWithDifferentPrices')
const Settings = () => import('@/views/point-of-sale/settings/Settings')
const SettingDiscountForCard = () => import('@/views/point-of-sale/settings/DiscountForCard')
const PriceControl = () => import('@/views/point-of-sale/PriceControl')
const CertificateList = () => import('@/views/point-of-sale/certificate/CertificateList')
const Sales = () => import('@/views/point-of-sale/sales/Sale')
const Kpi = () => import('@/views/point-of-sale/new_pos/kpi')

// Restaurant
const RestaurantGroup = () => import('@/views/restaurant/group')
const RestaurantProduct = () => import('@/views/restaurant/product')

// Views - User_Management
const Permissions = () => import('@/views/user-management/permissions/Permissions')
const Roles = () => import('@/views/user-management/roles/List')
const Roleperms = () => import('@/views/user-management/roles/RolePermissions')
const Users = () => import('@/views/user-management/users/Users')
const User = () => import('@/views/user-management/users/User')
const addUser = () => import('@/views/user-management/users/userComponents/addUser')
const updateUser = () => import('@/views/user-management/users/updateUser')

// References
const ParentRefs = () => import('@/views/references/ParentReferences')
const Reference = () => import('@/views/references/Reference')
const Contragents = () => import('@/views/references/Contragents')
const ShowSaldo = () => import('@/views/references/pages/ShowSaldo')
const Currency = () => import('@/views/references/Currencies')
const SkyCurrency = () => import('@/views/references/SkyCurrencies')

// Views - Analytics
const Analytics = () => import('@/views/analytics/Analytics');
// const WholeReport = () => import('@/views/analytics/WholeReport');
const Report = () => import('@/views/analytics/otchot/Остатки.vue');
const Report53 = () => import('@/views/analytics/otchot/Продажи по импорт.vue');
const Report54 = () => import('@/views/analytics/otchot/Остатки по импорт.vue');
const Report_5 = () => import('@/views/analytics/otchot/report5.vue');
const Report_51 = () => import('@/views/analytics/otchot/report51.vue');
const Report_52 = () => import('@/views/analytics/otchot/report52.vue');
const Report1 = () => import('@/views/analytics/otchot/Товарный отчет за период.vue');
const Report31 = () => import('../views/analytics/otchot/report31.vue');
const TotalSaleByPeriodAndDepartment = () => import('../views/analytics/otchot/TotalSaleByPeriodAndDepartment.vue');
const Report2 = () => import('@/views/analytics/otchot/Товарный отчет за период1.vue');
const Report3 = () => import('@/views/analytics/otchot/Товарооборот за период.vue');
const Report4 = () => import('@/views/analytics/otchot/Продажы по группам.vue');
const Report4o = () => import('@/views/analytics/otchot/Продажы по группам0.vue');
const Report41 = () => import('@/views/analytics/otchot/Продажы по группам1.vue');
const Report42 = () => import('@/views/analytics/otchot/Остатки по поставщикам.vue');
const Report5 = () => import('../views/analytics/otchot/Остатки по дням.vue');
const Report6 = () => import('../views/analytics/otchot/Списание за период.vue');
const ReportKpi = () => import('../views/analytics/otchot/report-kpi.vue');
const WarehousesPrices = () => import('../views/analytics/otchot/warehousePrices.vue');
const Report50 = () => import('@/views/analytics/otchot/report50');


// History
const ItemsHistory = () => import('../views/history/items-history.vue');
const DocsHistory = () => import('../views/history/docs-history.vue');

//Views - Contragent
const Contragent = () => import('@/views/contragent/index')
const RequestProduct = () => import('@/views/contragent/request-product.vue')
const ContragentOrder = () => import('@/views/contragent/request-product-view.vue')

//Views - Contragens
const ContragentsOrders = () => import('@/views/contragents/orders-list')
const ContragentOrderControl = () => import('@/views/contragents/order-control')
const ContragentOrderView = () => import('@/views/contragents/order-view')

Vue.use(Router)


const router = new Router({
	mode: 'history', // https://router.vuejs.org/api/#mode
	base: process.env.BASE_URL,
	linkActiveClass: 'open active',
	scrollBehavior: () => ({y: 0}),
	routes: [
		{
			path: '/',
			redirect: '/dashboard',
			name: 'Home',
			component: DefaultContainer,
			children: [
				{
					path: 'dashboard',
					name: 'Dashboard',
					component: Dashboard,
					// meta: {
					// 	hasPerm: () => ability.can('view', 'dashboard')
					// }
				},
				{
					path: 'contragent',
					name: ' Contragent',
					component: Contragent,
					meta: {
						hasPerm: () => TokenService.getIsContragent()
					}
				},
				{
					path: 'request-product',
					name: ' RequestProduct',
					component: RequestProduct,
					meta: {
						hasPerm: () => TokenService.getIsContragent()
					}
				},
				{
					path: 'item-history',
					name: ' ItemsHistory',
					component: ItemsHistory,
					// meta: {
					// 	hasPerm: () => TokenService.getIsContragent()
					// }
				},
				{
					path: 'doc-history',
					name: ' DocsHistory',
					component: DocsHistory,
					// meta: {
					// 	hasPerm: () => TokenService.getIsContragent()
					// }
				},
				{
					path: 'point-of-sale',
					redirect: '/point-of-sale/pos',
					name: 'Pos',
					component: {
						render(c) {
							return c('router-view')
						}
					},
					children: [
						{
							path: 'posList',
							name: 'PosList',
							component: PosList,
							meta: {
								hasPerm: false
							}
						},
						{
							path: 'report',
							name: 'PosReport',
							component: PosReport,
							meta: {
								hasPerm: () => ability.can('view', 'pos-reports')
							}
						},
						{
							path: 'beforePos',
							name: 'BeforePos',
							component: Settings
						},
						{
							path: 'prices',
							name: 'Prices',
							component: PriceList,
							meta: {
								hasPerm: () => ability.can('view', 'pricing')
							}
						},
						{
							path: 'itemWithDifferentPrices',
							name: 'ItemWithDifferentPrices',
							component: ItemWithDifferentPrices,
							meta: {
								hasPerm: () => ability.can('items', 'with different price')
							}
						},
						{
							name: 'PriceCreate',
							path: 'prices/create',
							component: PriceCreate
						},
						{
							path: 'priceControl',
							name: 'PriceControl',
							component: PriceControl,
							meta: {
								hasPerm: () => ability.can('view', 'pricing-percentage')
							}
						},
						{
							path: 'clients',
							name: 'Clients',
							component: Client,
							meta: {
								hasPerm: () => (TokenService.getDepSaleType() === 'RETAIL' && ability.can('view', 'clients')) || isAdmin
							}
						},
						{
							path: 'sale',
							name: 'Sale',
							component: PromoToProduct,
							meta: {
								hasPerm: () => ability.can('view', 'discounts')
							}
						},
						{
							path: 'discountForCard',
							name: 'SettingDiscountForCard',
							component: SettingDiscountForCard,
							meta: {
								hasPerm: () => ability.can('view', 'discount-for-card')
							}
						},
						{
							path: 'settings',
							name: 'Settings',
							component: Settings,
							meta: {
								hasPerm: () => true
							}
						},
						{
							path: 'certificates',
							name: 'CertificateList',
							component: CertificateList,
							meta: {
								hasPerm: () => ability.can('view', 'certificates')
							}
						},
						{
							path: 'sales',
							name: 'sales',
							component: Sales,
							meta: {
								hasPerm: () => (TokenService.getDepSaleType() === 'RETAIL' && ability.can('view', 'sales')) || isAdmin
							}
						}
					]
				},
				// <--------- Restaurant ---------
				{
					path: 'restaurant/group',
					name: 'Group',
					component: RestaurantGroup
				},
				{
					path: 'restaurant/product',
					name: 'Product',
					component: RestaurantProduct
				},
				{
					path: 'restaurant/pos',
					name: 'Group',
					href: 'http://localhost:8082/'
				},
				// --------- End Restaurant --------->
				{
					path: 'sky-shop',
					redirect: '/sky-shop/settings',
					name: 'SkyShop',
					component: {
						render(c) {
							return c('router-view')
						}
					},
					children: [
						{
							path: 'settings',
							name: 'Settings',
							component: SkySettings,
							meta: {
								hasPerm: () => ability.can('view', 'skyshop-setting')
							}
						},
						{
							path: 'doc',
							name: 'Doc',
							component: SkyDoc,
							meta: {
								hasPerm: () => ability.can('view', 'skyshop-doc')
							}
						},
						{
							path: 'report',
							name: 'SkyReport',
							component: SkyReport,
							meta: {
								hasPerm: () => ability.can('view', 'skyshop-doc')
							}
						},
						{
							path: 'brigade',
							name: 'Brigade',
							component: Brigade,
							meta: {
								hasPerm: () => ability.can('view', 'skyshop-setting')
							}
						}
					]
				},
				{
					path: 'contract',
					redirect: '/contract/type',
					name: 'ContractsManagement',
					component: {
						render(c) {
							return c('router-view')
						}
					},
					children: [
						{
							path: 'type',
							name: 'Type',
							component: ContractType,
							meta: {
								hasPerm: () => ability.can('view', 'contract-reference')
							}
						},
						{
							path: 'stage',
							name: 'Stage',
							component: ContractStage,
							meta: {
								hasPerm: () => ability.can('view', 'contract-reference')
							}
						},
						{
							path: 'doc',
							name: 'Doc',
							component: ContractDoc,
							meta: {
								hasPerm: () => ability.can('view', 'contract-doc')
							}
						}
					]
				},
				{
					path: 'warehouse-management',
					redirect: '/warehouse-management/warehouses',
					name: 'WareHouseManagement',
					component: {
						render(c) {
							return c('router-view')
						}
					},
					children: [
						{
							path: 'warehouses',
							name: 'Warehouses',
							component: Warehouse,
							meta: {
								hasPerm: () => ability.can('view', 'warehouses')
							}
						},
						{
							path: 'booking',
							name: 'BookingList',
							component: BookingList,
							meta: {
								hasPerm: () => ability.can('view', 'booking')
							}
						},
						{
							path: 'item-convert',
							name: 'ItemConvert',
							component: ItemConvert,
							meta: {
								hasPerm: () => ability.can('view', 'item-convert')
							}
						},
						{
							path: 'item-convert-create',
							name: 'ItemConvertCreate',
							component: ItemConvertCreate,
							meta: {
								hasPerm: () => ability.can('view', 'item-convert')
							}
						},
						{
							path: 'item-convert-view/:id',
							name: 'ItemConvertView',
							component: ItemConvertView,
							meta: {
								hasPerm: () => ability.can('view', 'item-convert')
							}
						},
						{
							path: 'report',
							name: 'WholeSaleReport',
							component: WholeSaleReport,
							meta: {
								hasPerm: () => (TokenService.getDepSaleType() === 'WHOLE' && ability.can('view', 'pos-whole-reports')) || isAdmin
							}
						},
						{
							path: 'goods',
							name: "Goods",
							component: Goods,
							meta: {
								hasPerm: () => ability.can('view', 'goods')
							}
						},
						{
							path: 'mxik',
							name: "Mxik",
							component: Mxik,
							meta: {
								hasPerm: () => ability.can('view', 'goods')
							}
						},
						{
							path: 'expired-items',
							name: "ExpiredItems",
							component: ExpiredItems,
							meta: {
								hasPerm: () => ability.can('view', 'expired-items')
							}
						},
						{
							path: 'min-max-values',
							name: "MinMaxValues",
							component: MinMaxValues,
							meta: {
								hasPerm: () => ability.can('view', 'min-max')
							}
						},
						{
							path: 'term-of-items',
							name: "TermOfItems",
							component: termOfItems,
							meta: {
								hasPerm: () => ability.can('view', 'spisatTermOfItem')
							}
						},
						{
							path: 'term-of-items/view/:action/:id',
							name: "TermOfItemsView",
							component: termOfItemsView,
							meta: {
								hasPerm: () => ability.can('view', 'spisatTermOfItem')
							}
						},
						{
							path: 'income',
							name: "Income",
							component: WhDocuments,
							meta: {
								hasPerm: () => ability.can('view', 'incomes')
							}
						},
						{
							path: 'expense',
							name: "Expenditure",
							component: WhDocuments,
							props: {section: 'chiqim'},
							meta: {
								hasPerm: () => ability.can('view', 'wh-expence')
							}
						},
						{
							path: 'transfers',
							name: "Transfers",
							component: WhDocuments,
							props: {section: 'kochirish'},
							meta: {
								hasPerm: () => ability.can('view', 'transfers')
							}
						},
						{
							path: 'transfer-by-document',
							name: "TransferByDocument",
							component: TransferByDocument,
							meta: {
								hasPerm: () => ability.can('view', 'transfer-by-document')
							}
						},
						{
							path: 'wholesale',
							name: "Wholesale",
							component: Wholesale,
							meta: {
								hasPerm: () => (TokenService.getDepSaleType() === 'WHOLE' && ability.can('view', 'wholesale')) || isAdmin
							}
						},
						{
							path: 'write-offs',
							name: "WriteOffs",
							component: WhDocuments,
							props: {section: 'spisat'},
							meta: {
								hasPerm: () => ability.can('view', 'write-offs')
							}
						},
						{
							path: 'inventory',
							name: "Inventory",
							component: Inventory,
							meta: {
								hasPerm: () => ability.can('view', 'inventory')
							},
						},
						{
							path: 'inventory/createOrUpdate/:action/:docId',
							name: "CreateOrUpdateInventory",
							component: InventoryCreateOrUpdate,
						},
						{
							name: 'sector',
							path: 'Sector',
							component: Sector,
							meta: {
								hasPerm: () => ability.can('view', 'sector')
							}
						},
						{
							path: 'adjustment',
							name: 'Adjustment',
							component: Adjustment,
							props: {section: 'adjustment'},
							meta: {
								hasPerm: () => ability.can('view', 'adjustment')
							}
						},
						{
							path: 'extra-cost',
							name: "Extra Cost",
							component: ExtraCost,
							meta: {
								hasPerm: () => ability.can('view', 'extra-cost')
							}
						},
						{
							path: 'expenses',
							name: "Expenses",
							component: Expenses,
							meta: {
								hasPerm: () => ability.can('view', 'expenses')
							}
						},
						{
							path: 'excel-export',
							name: "ExcelExport",
							component: ExcelExport,
							meta: {
								hasPerm: () => ability.can('view', 'excel-export')
							}
						},


					]
				},
				{
					path: 'reports',
					redirect: '/reports/list',
					name: 'Reports',
					component: {
						render(c) {
							return c('router-view')
						}
					},
					children: [
						{
							path: 'list',
							name: 'ReportsList',
							component: Empty
						}
					]
				},
				{
					path: 'contracts-management',
					redirect: '/contracts-management/contracts',
					name: 'ContractsManagement',
					component: {
						render(c) {
							return c('router-view')
						}
					},
					children: [
						{
							path: 'contracts',
							name: 'Contracts',
							component: Contracts,
							meta: {
								hasPerm: () => ability.can('view', 'contracts')
							}
						},
						{
							path: 'transactions',
							name: "Transactions",
							component: Transactions,
							meta: {
								hasPerm: () => ability.can('view', 'transactions')
							}
						}
					]
				},
				{
					path: 'user-management',
					redirect: '/user-management/roles',
					name: 'UserManagement',
					component: {
						render(c) {
							return c('router-view')
						}
					},
					children: [
						{
							path: 'roles',
							meta: {label: 'Roles'},
							redirect: '/',
							component: {
								render(c) {
									return c('router-view')
								}
							},
							children: [
								{
									path: '/',
									name: 'List',
									component: Roles,
									meta: {
										hasPerm: () => ability.can('view', 'roles') || isAdmin
									},
								},
								{
									path: ':id',
									name: 'RolePerms',
									component: Roleperms,
									meta: {
										hasPerm: () => ability.can('list', 'permissions by role') || isAdmin
									},
								}
							]
						},
						{
							path: 'permissions',
							name: "Permissions",
							component: Permissions,
							meta: {
								hasPerm: () => ability.can('view', 'permissions') || isAdmin
							},
						},
						{
							path: 'users',
							meta: {
								label: 'Users'
							},
							component: {
								render(c) {
									return c('router-view')
								}
							},
							children: [
								{
									path: '',
									component: Users,
									meta: {
										hasPerm: () => ability.can('view', 'users') || isAdmin
									},
								},
							]
						},
					]
				},
				{
					path: 'organization-structure',
					redirect: '/organization-structure/departments',
					name: 'OrganizationStructure',
					component: {
						render(c) {
							return c('router-view')
						}
					},
					children: [
						{
							path: 'departments',
							name: 'Departments',
							component: Departments,
							meta: {
								hasPerm: () => ability.can('view', 'departments') || isAdmin
							}
						},
						{
							path: 'employees',
							name: "Employees",
							component: Employees,
							meta: {
								hasPerm: () => ability.can('view', 'employees') || isAdmin
							}
						},
					]
				},
				{
					path: 'references',
					redirect: '/references/parentRefs',
					name: 'References',
					component: {
						render(c) {
							return c('router-view', {
								attrs: {
									key: "$router.fullPath"
								}
							})
						}
					},
					children: [
						{
							path: '/references/counterparties',
							name: "Counterparties",
							component: Contragents,
							meta: {
								hasPerm: () => (TokenService.getDepSaleType() === 'WHOLE' && ability.can('view', 'counterparties')) || isAdmin
							},
						},
						{
							path: '/references/currency-rates',
							name: "Currency rates",
							component: Currency,
							meta: {
								hasPerm: () => ability.can('view', 'currency-rates')
							}
						},
						{
							path: '/references/sky-currency-rates',
							name: "Sky Currency rates",
							component: SkyCurrency,
							meta: {
								hasPerm: () => ability.can('view', 'currency-rates')
							}
						},
						{
							path: '/references/parentRefs',
							name: 'ParentReferences',
							component: ParentRefs,
							meta: {
								hasPerm: () => ability.can('view', 'parent-references')
							}
						},
						{
							path: '/references/:referenceName',
							name: 'FirstChildReference',
							redirect: '/references/:referenceName',
							meta: {
								hasPerm: () => ability.can('view', 'references')
							},
							component: {
								render(c) {
									return c('router-view', {
										attrs: {
											key: "$route.params"
										}
									})
								}
							},
							children: [
								{
									path: '/references/:referenceName',
									name: 'Reference:referenceName',
									component: Reference,
									meta: {
										hasPerm: () => ability.can('view', 'references')
									},
								},
								{
									path: '/references/:referenceName/:subRefId',
									name: 'Reference:subRefId',
									component: Reference,
									meta: {
										hasPerm: () => ability.can('view', 'references')
									},
								},
								{
									path: '/references/:referenceName/:subRefId/:subRefId2',
									name: 'Reference:subRefId2',
									component: Reference,
									meta: {
										hasPerm: () => ability.can('view', 'references')
									},
								},
								{
									path: '/references/:referenceName/:subRefId/:subRefId2/:subRefCode3',
									name: 'Reference:subRefCode3',
									component: Reference,
									meta: {
										hasPerm: () => ability.can('view', 'references')
									},
								},
							]
						},

					]
				},
				{
					name: 'Analytics',
					path: '/analytics',
					component: Analytics,
					meta: {
						hasPerm: () => ability.can('view', 'analytics')
					}
				},
				// {
				// 	name: 'Analytics',
				// 	path: '/whole-report',
				// 	component: WholeReport,
				// 	meta: {
				// 		hasPerm: () => ability.can('view', 'analytics-by-item')
				// 	}
				// },
				{
					name: 'Report',
					path: 'report',
					component: Report,
					meta: {
						hasPerm: () => ability.can('view', 'analytics-by-item')
					}
				},
				{
					name: 'Report-5',
					path: 'report-5',
					component: Report_5,
					meta: {
						hasPerm: () => ability.can('view', 'analytics-by-item')
					}
				},
				{
					name: 'Report-51',
					path: 'report-51',
					component: Report_51,
					meta: {
						hasPerm: () => ability.can('view', 'analytics-by-item')
					}
				},
				{
					name: 'Report-52',
					path: 'report-52',
					component: Report_52,
					// meta: {
					// 	hasPerm: () => ability.can('view', 'analytics-by-item')
					// }
				},
				{
					name: 'Report-53',
					path: 'report-53',
					component: Report53,
					// meta: {
					// 	hasPerm: () => ability.can('view', 'analytics-by-item')
					// }
				},
				{
					name: 'Report-54',
					path: 'report-54',
					component: Report54,
					// meta: {
					// 	hasPerm: () => ability.can('view', 'analytics-by-item')
					// }
				},
				{
					name: 'Report50',
					path: 'report50',
					component: Report50,
					meta: {
						hasPerm: () => ability.can('view', 'analytics-by-item')
					}
				},
				{
					name: 'Report1',
					path: 'report1',
					component: Report1,
					meta: {
						hasPerm: () => ability.can('view', 'analytics-by-item')
					}
				},
				{
					name: 'Report31',
					path: 'report31',
					component: Report31,
					meta: {
						hasPerm: () => ability.can('view', 'analytics-by-item')
					}
				},
				{
					name: 'TotalSaleByPeriodAndDepartment',
					path: 'TotalSaleByPeriodAndDepartment',
					component: TotalSaleByPeriodAndDepartment,
					meta: {
						hasPerm: () => ability.can('view', 'total-sale-by-period-and-department') || ability.can('view', 'analytics-by-item')
					}
				},
				{
					name: 'Report2',
					path: 'report2',
					component: Report2,
					meta: {
						hasPerm: () => ability.can('view', 'analytics-by-item')
					}
				},
				{
					name: 'Report3',
					path: 'report3',
					component: Report3,
					meta: {
						hasPerm: () => ability.can('view', 'analytics-by-item')
					}
				},
				{
					name: 'Report4',
					path: 'report4',
					component: Report4,
					meta: {
						hasPerm: () => ability.can('view', 'analytics-by-item')
					}
				},
				{
					name: 'Report40',
					path: 'report40',
					component: Report4o,
					meta: {
						hasPerm: () => ability.can('view', 'analytics-by-item')
					}
				},
				{
					name: 'Report41',
					path: 'report41',
					component: Report41,
					meta: {
						hasPerm: () => ability.can('view', 'analytics-by-item')
					}
				},
				{
					name: 'Report42',
					path: 'report42',
					component: Report42,
					meta: {
						hasPerm: () => ability.can('view', 'analytics-by-item')
					}
				},
				{
					name: 'Report5',
					path: 'report5',
					component: Report5,
					meta: {
						hasPerm: () => ability.can('view', 'analytics-by-item')
					}
				},
				{
					name: 'Report6',
					path: 'report6',
					component: Report6,
					meta: {
						hasPerm: () => ability.can('view', 'analytics-by-item')
					}
				},
				{
					name: 'ReportKpi',
					path: 'report-kpi',
					component: ReportKpi,
					meta: {
						hasPerm: () => ability.can('view', 'analytics-by-item')
					}
				},
				{
					path: 'contragents',
					name: 'Contragents',
					redirect: '/contragents/orders',
					component: {
						render(c) {
							return c('router-view')
						}
					},
					children: [
						{
							path: 'orders',
							name: 'Index',
							component: ContragentsOrders,

						}
					]
				},
				{
					path: 'request-warehouse',
					redirect: '/request-warehouse/Index',
					name: 'RequestWarehouse',
					component: {
						render(c) {
							return c('router-view')
						}
					},
					children: [
						// {
						// 	path: 'index',
						// 	name: 'Index',
						// 	component: Index,
						// 	meta: {
						// 		hasPerm: () => ability.can('view', 'request-less-than-five')
						// 	}
						// },
						// {
						// 	path: 'transfer',
						// 	name: 'RequestTransfer',
						// 	component: RequestTransfer,
						// 	meta: {
						// 		hasPerm: () => ability.can('view', 'request-documents')
						// 	}
						// },
						// {
						// 	path: 'items',
						// 	name: 'RequestItems',
						// 	component: RequestItems,
						// 	meta: {
						// 		hasPerm: () => ability.can('view', 'request-to-manufacturer')
						// 	}
						// },
						{
							path: 'transfer',
							name: 'RequestTransfer',
							component: RequestTransfer,
							meta: {
								hasPerm: () => ability.can('view', 'request-documents')
							}
						},
						// {
						// 	path: 'create_or_edit/:id/:action',
						// 	name: 'CreateRequestTransfer',
						// 	component: CreateOrUpdateRequestTransfer
						// },
						{
							path: 'counter',
							name: 'RequestCounter',
							component: RequestCounter,
							meta: {
								hasPerm: () => ability.can('view', 'checking request-documents')
							}
						},
						{
							path: 'create_or_edit_counter/:id',
							name: 'CreateRequestTransfer',
							component: CreateOrUpdateRequestCounter
						},
					]
				},
			],
		},
		{
			path: '/warehouse-management/warehouses-for-pos',
			name: 'WarehousesForPos',
			component: WarehouseForPos,
			meta: {
				hasPerm: () => ability.can('view', 'warehouses')
			}
		},
		{
			path: '/warehouse-management/warehouses/prices',
			name: 'WarehousePrices',
			component: WarehousePrices,
			meta: {
				hasPerm: () => ability.can('view', 'warehouses')
			}
		},
		{
			path: '/point-of-sale/prices-generate/:id/:depId',
			name: 'PricingPrices',
			component: PricingPrices
		},
		{
			path: '/report5/warehouse-prices',
			name: 'WarehousesPrices',
			component: WarehousesPrices
		},
		{
			path: '/warehouse-management/transfers/prices-generate/:id/:depName',
			name: 'TransferPrices',
			component: TransferPrices
		},
		{
			name: 'Order-view',
			path: '/contragents/orders/:id/view',
			component: ContragentOrderView,
			meta: {
				// hasPerm: () => TokenService.getIsContragent()
			}
		},
		{
			name: 'Order-control',
			path: '/contragents/orders/:id/control',
			component: ContragentOrderControl,
			meta: {
				// hasPerm: () => TokenService.getIsContragent()
			}
		},
		{
			name: 'Order-document',
			path: '/request-product/view/:id',
			component: ContragentOrder,
			meta: {
				hasPerm: () => TokenService.getIsContragent()
			}
		},
		{
			name: 'Request document',
			path: '/request-warehouse/income-request/view/:id',
			component: RequestDocumentShow
		},
		{
			name: 'Request document',
			path: '/request-warehouse/production-request/view/:id',
			component: RequestDocumentPro
		},

		{
			path: '/point-of-sale/pos',
			name: 'Pos',
			component: Pos,
			meta: {
				hasPerm: () => TokenService.getDepSaleType() === 'RETAIL' && ability.can('view', 'pos')
			}
		},
		{
			path: '/point-of-sale/pos/barcode',
			name: 'PriceBarcodeGenerate',
			component: PriceBarcodeGenerate,
		},
		{
			path: '/point-of-sale/sale/barcodes',
			name: 'Sale',
			component: BarcodeDiscount,
			meta: {
				hasPerm: () => ability.can('view', 'discounts')
			}
		},
		{
			path: '/counterparties/:id/saldo',
			name: "ShowSaldo",
			component: ShowSaldo,
			meta: {
				hasPerm: () => true
			}
		},
		{
			path: '/contragent/:id/saldo',
			name: "ShowSaldo",
			component: ShowSaldo,
			meta: {
				hasPerm: () => TokenService.getIsContragent()
			}
		},
		{
			name: "BarcodeGeneratePage",
			path: '/barcode-generate',
			component: BarcodeGeneratePage
		},
		{
			name: "BeforePos",
			path: '/point-of-sale/before-pos',
			component: beforePos
		},
		{
			name: "TransferIncome",
			path: '/point-of-sale/transfer-income',
			component: transferIncome
		},
		{
			name: "BeforePos",
			path: '/point-of-sale/sales-for-seller/:depId/:cashId',
			component: salesForSeller
		},
		{
			name: "KpiPos",
			path: '/point-of-sale/kpi/:depId',
			component: Kpi
		},
		{
			name: "BeforePos",
			path: '/point-of-sale/pos-v2/:depId/:cashId',
			component: posV2
		},
		{
			name: 'Warehouse document Transfer View',
			path: '/warehouse-management/transfers/view/:id',
			component: TNakladnoy
		},
		{
			name: 'Contract Doc View',
			path: '/contract/doc/view/:id',
			component: ContractViewDoc
		},
		{
			name: 'Sky Shop Nakladnoy',
			path: '/warehouse-management/skyShop/view/:id',
			component: SkyDocNakladnoy
		},
		{
			name: 'Sky Shop Report Nakladnoy',
			path: '/warehouse-management/skyShopReport/view/:id',
			component: reportNakladnoy
		},
		{
			name: 'Warehouse document qwe',
			path: '/warehouse-management/income-view/:action/:id',
			component: naklodnoyNew
		},
		{
			name: 'PricingDoc',
			path: '/point-of-sale/prices/doc/:id/:depId',
			component: pricingNakladnoy
		},
		{
			name: 'Warehouse document',
			path: '/26',
			component: naklodnoyPeredacha
		},
		{
			name: 'Warehouse document',
			path: '/27',
			component: Act
		},
		{
			name: 'Warehouse document',
			path: '/warehouse-management/transfers/view-aviz/:id',
			component: Aviz
		},
		{
			name: 'Warehouse document',
			path: '/warehouse-management/transfers/view-aviz-all/:id',
			component: AvizDocAll
		},
		{
			name: 'Warehouse document',
			path: '/warehouse-management/income/view/:id',
			component: WhShow
		},
		{
			name: 'Warehouse document',
			path: '/warehouse-management/writeOff/view/:id',
			component: WriteOffNakladnoy
		},
		{
			name: 'Warehouse document',
			path: '/warehouse-management/income/pricing/:id',
			component: Pricing
		},
		{
			name: 'Warehouse document',
			path: '/warehouse-management/income/views/:id',
			component: CheckNaklodnoy
		},
		{
			name: 'Warehouse document',
			path: '/warehouse-management/income/act/:action/:id',
			component: ActExprationKirim
		},
		{
			name: 'Warehouse document',
			path: '/warehouse-management/transfers/pricing/:id',
			component: transferPricing
		},
		{
			name: 'CreateRequestTransfer',
			path: '/request-warehouse/create_or_edit/:id/:action',
			component: CreateOrUpdateRequestTransfer
		},
		{
			name: 'Warehouse document',
			path: '/warehouse-management/pendingIncome/view/:id',
			component: WhShowPendingIncome
		},
		{
			name: 'NakladnoyWholesale',
			path: '/warehouse-management/wholesale/view/:id',
			component: NakladnoyWholesale
		},
		{
			name: 'NakladnoyWholesale',
			path: '/warehouse-management/wholesale/view/:id/romaniya',
			component: RuminyaNakladnoyWholesale
		},
		{
			name: 'NakladnoyWholesale',
			path: '/warehouse-management/wholesale/grid-view/:id',
			component: NakladnoyWithGrid
		},
		{
			name: 'Warehouse document',
			path: '/warehouse-management/income/barcodes',
			component: BarcodeGenerate
		},
		{
			name: 'PricePrint',
			path: '/warehouse-management/price/print',
			component: PricePrint
		},
		{
			name: 'Warehouse document',
			path: '/warehouse-management/goods/barcode/:itemId/:depId/:id/:count',
			component: BarcodeGenerateForGoods
		},
		{
			name: 'Warehouse document',
			path: '/warehouse-management/income/barcode/:id',
			component: BarcodeGenerateForIncome
		},
		{
			name: 'Good prices',
			path: '/goods/print-prices/:itemId/:depId/:count/:barcode',
			component: PriceGenerateForGoods
		},

		{
			name: 'Warehouse document',
			path: '/warehouse-management/income/pending/:id',
			component: Pending
		},

		{
			name: 'Warehouse document',
			path: '/warehouse-management/pendingIncome/edit/:id',
			component: PendingIncome
		},
		{
			name: 'PendingIncomeFromSale',
			path: '/warehouse-management/pendingIncome/fromSale/edit/:id',
			component: PendingIncomeFromSale
		},
		{
			path: '/inventory/print/:id',
			name: "Inventory",
			component: InventoryPrint
		},
		{
			name: 'Warehouse document',
			path: '/warehouse-management/extra-cost/:id',
			component: ExtraShow
		},
		{
			path: '/pages',
			redirect: '/pages/404',
			name: 'Pages',
			component: {
				render(c) {
					return c('router-view')
				}
			},
			children: [
				{
					path: '500',
					name: 'Page500',
					component: Page500
				},
				{
					path: 'login',
					name: 'Login',
					component: Login,
					meta: {
						public: true,
						onlyWhenLoggedOut: true
					}
				},
				{
					path: '**',
					name: 'Page404',
					component: Page404
				},
			]
		},
		{
			path: '*',
			redirect: '/dashboard',
			name: 'not-found',
		}
	]
});

router.beforeEach((to, from, next) => {
	let isCashier = TokenService.getIsCashier();
	let isMonitoring = TokenService.getIsMonitoring();
	// let isContragent = TokenService.getIsContragent()
	const loggedIn = !!TokenService.getToken();

	const isPublic = to.matched.some(record => record.meta.public);

	// CHECK IF USER HAS PERMISSION FOR THIS URL
	const isOpen = ('hasPerm' in to.meta) ? !!to.meta.hasPerm() : true;

	const onlyWhenLoggedOut = to.matched.some(record => record.meta.onlyWhenLoggedOut);

	if (!isPublic && !loggedIn && to.path !== '/pages/login') {
		return next({
			path: '/pages/login',
			query: {redirect: to.fullPath}
		})
	}

	if (!isOpen) {
		return next('/');
	}

	if (loggedIn && onlyWhenLoggedOut) {
		return next('/');
	}

	next();
});

export default router;
